import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

declare interface RouteInfo {
  text1: string
  text2: string
  text3: string
  listTitle: string
  list1: string
  list2: string
  list3: string
  list4: string
  list5: string
  list6: string
}

export const AnnualConventionContent: RouteInfo[] = [
  {
    text1:
      'The CHCC strives to develop long-term commitments and engagement with our Corporate Partners and members. The mission of the CHCC Partnership and Membership Program (CPMP)is to create and continuously promote the growth of Hispanic and diverse businesses and communities for the common benefit of our members and corporate partners.',
    text2:
      "The CHCC's CPMP provides our corporate partners with a platform and leadership opportunity to get involved with the CHCC through our Corporate Council (CCC) and our Procurement, Diversity, and Inclusion Council (PDIC). Through these two councils, corporate partners have the opportunity to advise CHCC leadership on industry-specific concerns and provide insight, as well as share industry and company-specific legislative challenges to help shape and inform the CHCC's Policy Platform. In addition, you will have the opportunity to support the growth of businesses of all sizes in the Hispanic and diverse communities by advising on the scope and approach that CHCC programs utilize to strengthen local chambers and Hispanic and diverse companies. You will also encourage the participation of supplier diversity professionals in award nominations, matchmaking sessions, and other CHCC opportunities.",
    text3:
      'I look forward to discussing with you further the opportunities that exist through the CHCC’s Corporate Partnership and Membership program.',
    listTitle:
      'The Benefits of Working with the CHCC and the Hispanic Business Community',
    list1:
      "Small business is the backbone of California's economy – 97% of all businesses in California are small businesses.",
    list2: 'There are over 815,000 Hispanic-owned businesses in California.',
    list3:
      'Hispanic businesses in California generate over $200 billion in annual revenue.',
    list4:
      'Hispanics are the largest minority in California, making up 40% of the current population.',
    list5:
      "The purchasing power of California's Hispanic community is currently over $500 billion.",
    list6:
      "Hispanic-owned businesses are the future of California's economy, growing three times the national average compared to the general market. Women within this segment are starting new enterprises at five times the rate of their male counterparts.",
  },
]
export const SecondBullets: RouteInfo[] = [
  {
    text1: '',
    text2: '',
    text3: '',
    listTitle: 'Highlights of the CHCC Corporate and Membership Program',
    list1:
      "Join the organization that represents the nation's fastest-growing sector of the business community.",
    list2:
      'Collaborate with your corporate peers to help shape the CHCC in policy and supplier development.',
    list3:
      'Build your network and brand through our annual events; The California Business Policy Summit, The CHCC Statewide Convention, and the CHCC Legislative and Economic Forecast.',
    list4:
      'Grow the economic prospects for small businesses and the Hispanic business community by providing corporate support and development.',
    list5: '',
    list6: '',
  },
]

@Component({
    selector: 'app-corporate-partnership-program',
    templateUrl: './corporate-partnership-program.component.html',
    styleUrls: ['./corporate-partnership-program.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CorporatePartnershipProgramComponent implements OnInit {
  mainTitle = 'Corporate Partnership Program'
  texts: any = []
  secondLists: any = []

  constructor() {}

  ngOnInit(): void {
    this.texts = AnnualConventionContent.filter((text) => text)
    this.secondLists = SecondBullets.filter((secondList) => secondList)
  }
}
